export default {
      id: "ic_signalement-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic_signalement-usage",
      toString: function () {
        return this.url;
      }
    }